import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Subregion, SubregionAssignment } from '../loanofficerregionreference.model';
import { SubregionService } from '../subregions/subregions.service';

@Component({
  selector: 'app-subregion-list',
  templateUrl: './subregion-list.component.html',
  styleUrls: ['./subregion-list.component.css']
})
export class SubregionListComponent implements OnInit {

    public subregions: Subregion[];
    public subregionAssignments: SubregionAssignment[];

    @Input() subregionName: string;
    @Output() updated = new EventEmitter<any>();
    constructor(private subregionService: SubregionService) { }

    async ngOnInit() {
        this.subregions = await this.subregionService.getSubregions();

        var selectedSubregion = this.subregions.find(subregion => subregion.name == this.subregionName);
        var unsortedSubregionAssignments = await this.subregionService.getSubregionAssignments(selectedSubregion.id);
        this.subregionAssignments = unsortedSubregionAssignments.sort((a, b) => a.city.localeCompare(b.city));

        this.subregionService.subregionAssignmentAdded
            .subscribe((subregionAssignment: SubregionAssignment) => {
                if (selectedSubregion.id == subregionAssignment.subregionId) {
                    this.subregionAssignments.push(subregionAssignment);
                    this.subregionAssignments = this.subregionAssignments.sort((a, b) => a.city.localeCompare(b.city));
                }               
            });
        this.subregionService.subregionAssignmentUpdated
            .subscribe((subregionAssignment: SubregionAssignment) => {
                var subregionToUpdate = this.subregionAssignments.find(x => x.id === subregionAssignment.id);
                subregionToUpdate.city = subregionAssignment.city;
                this.updated.emit(false);
            });
        this.subregionService.subregionAssignmentDeleted
            .subscribe((subregionAssignmentId: string) => {
                var subregionAssignmentIndex = this.subregionAssignments.findIndex(t => t.id === subregionAssignmentId);
                this.subregionAssignments.splice(subregionAssignmentIndex, 1);
            });
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/loan-officer-region-reference/subregion-list/subregion-list.component.ts